import { Link } from 'react-router-dom';
import { movies, categories } from '@/mocks/movies';

export default function LatestUpdates() {
  const latestMovies = [...movies]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  const hotMovies = [...movies]
    .filter((m) => m.hot)
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10" aria-label="最新更新与热门排行">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新更新</h2>
              <Link
                to="/category/movie"
                className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                全部更新 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              {latestMovies.map((movie, index) => (
                <Link
                  key={movie.id}
                  to={`/movie/${movie.id}`}
                  className="flex items-center gap-3 md:gap-4 p-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
                >
                  <div className="w-16 h-20 md:w-20 md:h-28 flex-shrink-0 rounded-lg overflow-hidden relative">
                    <img
                      src={movie.poster}
                      alt={movie.title}
                      title={`${movie.title} - 天堂影院`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 whitespace-nowrap">
                        {getCategoryName(movie.category)}
                      </span>
                      <span className="text-xs text-foreground-400">{movie.updateDate}</span>
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                      {movie.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 line-clamp-1 hidden sm:block">
                      {movie.description}
                    </p>
                    <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-400">
                      <span>{movie.year}</span>
                      <span>·</span>
                      <span>{movie.region}</span>
                      <span>·</span>
                      <span className="flex items-center gap-0.5">
                        <i className="ri-star-fill text-accent-400"></i> {movie.rating}
                      </span>
                    </div>
                  </div>
                  <div className="hidden sm:block text-xs text-foreground-300 whitespace-nowrap">
                    #{index + 1}
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热门排行</h2>
              <Link
                to="/category/tv"
                className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5">
              {hotMovies.map((movie, index) => (
                <Link
                  key={movie.id}
                  to={`/movie/${movie.id}`}
                  className={`flex items-center gap-3 py-3 cursor-pointer group ${
                    index < hotMovies.length - 1 ? 'border-b border-background-200/70' : ''
                  }`}
                >
                  <span
                    className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                      index < 3
                        ? 'bg-primary-500 text-white'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                      {movie.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-0.5 text-xs text-foreground-400">
                      <span>{movie.year}</span>
                      <span>·</span>
                      <span className="flex items-center gap-0.5">
                        <i className="ri-star-fill text-accent-400"></i> {movie.rating}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}